export default "__VITE_ASSET__8Hi4n$yKUsgZDE1jxHw7Dg__";